// demo grids
import altGridDef from "./altGrid.js";
import altGrid2Def from "./altGrid2.js";
import altGrid3Def from "./altGrid3.js";
import altGrid4Def from "./altGrid4.js";

// full grids by media size
import fullGridDef   from "./fullGrid.js";
import fullGridLgDef from "./fullGrid-lg.js";
import fullGridMdDef from "./fullGrid-md.js";
import fullGridXsDef from "./fullGrid-xs.js";

// small grids (short number of slides)
import smallGrid1 from "./smallGrid1.js";
import smallGrid2 from "./smallGrid2.js";
import smallGrid3 from "./smallGrid3.js";
import smallGrid4 from "./smallGrid4.js";
import smallGrid5 from "./smallGrid5.js";
import smallGrid6 from "./smallGrid6.js";


// import cloneDeep from "lodash/clonedeep";
function cloneDeep (clonable) {
    // lodash.cloneDeep added 11K
    // NOTE: works only for JSON data types!
    // Fit to clone the gridDef template structures.
    return JSON.parse(JSON.stringify(clonable));
}

const DEBUG = false;

const gridLibrary = {
    xs: {
        fullGrid: fullGridXsDef,
    },
    md: {
        fullGrid: fullGridMdDef,
    },
    lg: {
        fullGrid: fullGridLgDef,
    },
    desktop: {
        fullGrid: fullGridDef,
        smallGrids: [
            // list of objects for numOrLess number of slides (or less)
            // gone through in order, so, start small, first match stops
            // search.
            {
                numOrLess: 1,
                gridDef: smallGrid1,
            },
            {
                numOrLess: 2,
                gridDef: smallGrid2,
            },
            {
                numOrLess: 3,
                gridDef: smallGrid3,
            },
            {
                numOrLess: 4,
                gridDef: smallGrid4,
            },
            {
                numOrLess: 5,
                gridDef: smallGrid5,
            },
            {
                numOrLess: 6,
                gridDef: smallGrid6,
            },
        ],
    },
    altGrid: {
        "altGrid": altGridDef,
        "altGrid2": altGrid2Def,
        "altGrid3": altGrid3Def,
        "altGrid4": altGrid4Def,
    }
};


function pickGridTemplate(opts){
    /*  opts
        {
            mediaType: xs | md | lg | desktop,
            slides: slides array (for length but more details could be used),
            altGrid: if there is an altGrid chosen
        }
    */
    let gridDefTemplate;
    if (DEBUG) console.log("ll44: pick template", opts);
    const {mediaType, slides, useGrid} = opts;
    if (!useGrid) {
        // check small list formats
        const smallGrids = gridLibrary[mediaType].smallGrids;
        if (smallGrids) {
            const numslides = slides.length;
            for ( let smallGrid of smallGrids) {
                if (DEBUG) console.log("ll67: check smallGrid", smallGrid);
                if (numslides <= smallGrid.numOrLess) {
                    if (DEBUG) console.log("ll67: found smallGrid", smallGrid);
                    gridDefTemplate = smallGrid.gridDef;
                    break;
                }
            }
        }

        // default
        if (!gridDefTemplate) {
            gridDefTemplate = gridLibrary[mediaType].fullGrid;
        }
    }
    else {
        const templateGridDefKey = useGrid ? useGrid :  null;
        gridDefTemplate = gridLibrary.altGrid[templateGridDefKey] ?
                            gridLibrary.altGrid[templateGridDefKey]
                            : fullGridDef;
    }
    if (!gridDefTemplate) gridDefTemplate = fullGridDef;
    const freshCopy = cloneDeep(gridDefTemplate);
    return freshCopy;
}

export default pickGridTemplate;
